import React from "react";

import { useFlow } from "src/api/queries";
import { Spinner } from "src/base-components/Spinner";
import { flowFolderScope } from "src/hooks/useCapabilities/flowFolderScope";
import { Capabilities, FlowFolderScope } from "src/hooks/useCapabilities/types";
import { ProtectedPage } from "src/router/ProtectedPage";
import { FlowPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type Props = {
  children: React.ReactNode;
  canAccess: (capabilities: Capabilities, folder: FlowFolderScope) => boolean;
  unauthorizedMessage?: string;
};

export const ProtectedFlowPage: React.FC<Props> = ({
  children,
  canAccess,
  unauthorizedMessage,
}) => {
  const { flow_id: flowId } = useParamsDecode<FlowPageParams>();
  const { data: flow, isLoading } = useFlow(flowId);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <ProtectedPage
      canAccess={(c) => canAccess(c, flowFolderScope(flow))}
      unauthorizedMessage={unauthorizedMessage}
    >
      {children}
    </ProtectedPage>
  );
};
